import { PUBLIC_TRIBE_CLOUDFRONT_URL } from "./constants";

export function getPublicAssetURL(id: string) {
  return `${PUBLIC_TRIBE_CLOUDFRONT_URL}/${id}`;
}
